import React, { useEffect, useRef, useState } from "react";
import DataTables from "../../CommonDataTable/DataTable";
import apiCalls from "../../../../config/apiCalls";
import store from "../../../App/store";
import filePath from "../../../../config/configSampleFiles";
import fetchMethodRequest from "../../../../config/service";
import RolePermissions from "../../CommonModals/Permissions";
import { useNavigate, useParams } from "react-router";
import "./SideBySideLayout.css";
import { useSearchParams } from "react-router-dom";
import AgreementTemplates from "./AgeementTemplates";
import config from "../../../../config/config";

const AgreementFiles = (props) => {
  const [languageData, setLanguageData] = useState();
  const [rolePermission, setRolePermission] = useState();
  const [rolesList, setRolesList] = useState([]);
  const [gotRoles, setgotRoles] = useState(false);
  const [editSelectedRecord, setEditSelectedRecord] = useState(
    window.location.href.includes("edit")
  );
  const [addSelectedRecord, setAddSelectedRecord] = useState(
    window.location.href.includes("create")
  );
  const [viewSelectedRecord, setViewSelectedRecord] = useState(
    window.location.href.includes("view")
  );

  const [searchParams] = useSearchParams();
  const agreementTemplatesId = searchParams.get("template");
  const [showSideMenu, setShowSideMenu] = useState(true);

  const [templateFields, setTemplateFields] = useState([]);
  const navigate = useNavigate();

  const [agreementTemplates, setAgreementTemplates] = useState([]);
  const currentTemplate = agreementTemplates.find(
    (temp) => temp._id === agreementTemplatesId
  );
  const params = useParams();

  useEffect(() => {
    getRoleListFromServer();
    fetchAgreementTemplates();
    let screenPermissions = RolePermissions.screenPermissions("Agreement Templates");
    if (screenPermissions) {
      setRolePermission(screenPermissions);
    }
  }, []);

  useEffect(() => {
    if (agreementTemplatesId && agreementTemplates.length > 0) {
      const selectedTemplate = agreementTemplates.find(
        (temp) => temp._id === agreementTemplatesId
      );

      if (selectedTemplate && selectedTemplate.templateVariables) {
        setTemplateFields(selectedTemplate.templateVariables);
      } else {
        setTemplateFields([]);
      }
    }
  }, [agreementTemplatesId, agreementTemplates]);

  const setData = () => {
    let rowData = {};
    if (params.id) {
      rowData["_id"] = JSON.parse(params.id);
      return rowData;
    }
  };

  const getRoleListFromServer = async () => {
    let filterCriteria = {},
      url;
    filterCriteria.direction = "asc";
    url = `roles?filter=${JSON.stringify(filterCriteria)}`;
    fetchMethodRequest("GET", url)
      .then(async (res) => {
        if (res && res.roles && res.roles.length > 0) {
          let rolesList = [];
          for (let obj of res.roles) {
            if (obj.role) rolesList.push({ value: obj.role, label: obj.role });
          }
          setRolesList(rolesList);
          setgotRoles(true);
        }
      })
      .catch(() => {
        setgotRoles(true);
      });
  };
  const getTableFields = () => {
    const priorityTypes = [
      { label: "All", value: null, color: "secondary" },
      { label: "High", value: "High", color: "danger" },
      { label: "Medium", value: "Medium", color: "success" },
      { label: "Low", value: "Low", color: "warning" },
    ];

    const roleTypes = [
      { label: "All", value: null },
      { label: "Admin", value: "Admin" },
      { label: "Manager", value: "Manager" },
      { label: "Guest", value: "Guest" },
    ];

    const categoryTypes = [
      { label: "All", value: null, color: "secondary" },
      { label: "Functional", value: "Functional", color: "success" },
      { label: "User Interface (UI)", value: "UI", color: "primary" },
      { label: "Integration", value: "Integration", color: "info" },
      { label: "System", value: "System", color: "warning" },
      { label: "Acceptance (UAT)", value: "UAT", color: "success" },
      { label: "Security", value: "Security", color: "danger" },
      { label: "Regression", value: "Regression", color: "secondary" },
      { label: "Compatibility", value: "Compatibility", color: "info" },
    ];

    let data = [
      {
        textAlign: "center",
        width: "40px",
        field: "Check Box",
        label: "Check Box",
        fieldType: "multiple",
        header: "",
        selectionMode: "multiple",
        show: true,
        mobile: true,
        displayInSettings: true,
        displayinlist: "false",
        displayinaddForm: "false",
        displayineditForm: "false",
        globalSearchField: "false",
        isFieldRequired: "false",
        tDisplay: true,
      },
      {
        textAlign: "center",
        width: "40px",
        field: "Sno",
        label: "SNo",
        header: "SNo",
        sortable: false,
        show: true,
        mobile: true,
        displayInSettings: true,
        tDisplay: true,
      },
      // {
      //   name: "fileName",
      //   type: "text",
      //   placeholder: "File Name",
      //   label: "File Name",
      //   header: "File Name",
      //   width: 150,
      //   id: "fileName",
      //   displayinaddForm: "true",
      //   displayineditForm: "true",
      //   displayinlist: "true",
      //   controllerName: null,
      //   textAlign: "left",
      //   globalSearchField: "true",
      //   show: true,
      //   field: "fileName",
      //   isFieldRequired: "false",
      //   mobile: true,
      //   displayInSettings: true,
      //   tDisplay: true,
      //   displayIcon: true,
      //   filter: true,
      // },
      {
        name: "fileName",
        type: "text",
        placeholder: "File",
        label: "File",
        header: "File",
        width: 350,
        id: "fileName",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        controllerName: null,
        fieldType: "redirectable",
        fileViewType: 'view',
        textAlign: "left",
        globalSearchField: "true",
        show: true,
        field: "fileName",
        isFieldRequired: "false",
        mobile: true,
        displayInSettings: true,
        tDisplay: true,
        displayIcon: true,
        fieldTypes: 'fileUpload',
        filter: true,
        redirectFilterField: 'parentFolderId',
        redirecTo: 'myDocuments',
        // iconName : 'folder',
        showIcon: true,
      },
      // {
      //   name: "EMPLOYEE_NAME",
      //   type: "text",
      //   placeholder: "EMPLOYEE_NAME",
      //   label: "EMPLOYEE_NAME",
      //   header: "Employee Name",
      //   width: 150,
      //   id: "EMPLOYEE_NAME",
      //   displayinaddForm: "true",
      //   displayineditForm: "true",
      //   displayinlist: "true",
      //   controllerName: null,
      //   textAlign: "center",
      //   globalSearchField: "true",
      //   show: true,
      //   field: "EMPLOYEE_NAME",
      //   isFieldRequired: "false",
      //   mobile: true,
      //   displayInSettings: true,
      //   tDisplay: true,
      //   filter: true,
      //   showIcon: true,
      // },
      // {
      //   name: "WORK_LOCATION",
      //   type: "text",
      //   placeholder: "Work Location",
      //   label: "Work Location",
      //   width: "120px",
      //   header: "Work Location",
      //   sortable: true,
      //   filter: true,
      //   textAlign: "left",
      //   show: true,
      //   field: "WORK_LOCATION",
      //   fieldType: "text",
      //   displayinaddForm: "true",
      //   displayineditForm: "true",
      //   displayinlist: "true",
      //   globalSearchField: "true",
      //   required: true,
      //   displayInSettings: true,
      //   tDisplay: true,
      //   style: {
      //     textAlign: "center",
      //     whiteSpace: "normal",
      //     wordWrap: "break-word",
      //     overflowWrap: "anywhere"

      //   }
      // },
      // {
      //   name: "WORK_LOCATION",
      //   type: "text",
      //   placeholder: "Work Location",
      //   label: "Work Location",
      //   width: "120px",
      //   header: "Work Location",
      //   sortable: true,
      //   filter: true,
      //   textAlign: "left",
      //   show: true,
      //   field: "WORK_LOCATION",
      //   fieldType: "text",
      //   displayinaddForm: "true",
      //   displayineditForm: "true",
      //   displayinlist: "true",
      //   globalSearchField: "true",
      //   required: true,
      //   displayInSettings: true,
      //   tDisplay: true,
      //   style: {
      //     textAlign: "center",
      //     whiteSpace: "normal",
      //     wordWrap: "break-word",
      //     overflowWrap: "anywhere"

      //   }
      // },
      // {
      //   name: "category",
      //   type: "dropDown",
      //   placeholder: "Category",
      //   label: "Category",
      //   header: "Category",
      //   field: "category",
      //   options: categoryTypes,
      //   width: "120px",
      //   textAlign: "center",
      //   show: true,
      //   displayinaddForm: "true",
      //   displayineditForm: "true",
      //   displayinlist: "true",
      //   globalSearchField: "true",
      //   required: true,
      //   displayInSettings: true,
      //   fieldType: "dropDown",
      //   tDisplay: true,
      //   sortable: true,
      //   filter: true,
      //   style: {
      //     textTransform: 'uppercase'
      //   }
      // },
      // {
      //   name: "description",
      //   type: "textarea",
      //   placeholder: "Description",
      //   label: "Description",
      //   width: "300px",
      //   header: "Description",
      //   field: "description",
      //   show: true,
      //   textAlign: "left",
      //   displayinaddForm: "true",
      //   displayineditForm: "true",
      //   displayinlist: "true",
      //   globalSearchField: "true",
      //   required: false,
      //   displayInSettings: true,
      //   tDisplay: true,
      //   style: {
      //     whiteSpace: "normal",
      //     wordWrap: "break-word",
      //     overflowWrap: "anywhere"
      //   }
      // },
      // {
      //   name: "preconditions",
      //   type: "textarea",
      //   placeholder: "Preconditions",
      //   label: "Preconditions",
      //   width: "250px",
      //   header: "Preconditions",
      //   field: "preconditions",
      //   show: true,
      //   textAlign: "left",
      //   displayinaddForm: "true",
      //   displayineditForm: "true",
      //   displayinlist: "true",
      //   globalSearchField: "false",
      //   required: false,
      //   displayInSettings: true,
      //   tDisplay: true,
      //   style: {
      //     whiteSpace: "normal",
      //     wordWrap: "break-word",
      //     overflowWrap: "anywhere"
      //   }
      // },
      // {
      //   name: "steps",
      //   type: "ckeditor",
      //   placeholder: "Steps",
      //   label: "Steps",
      //   width: "250px",
      //   header: "Steps",
      //   field: "steps",
      //   show: false,
      //   textAlign: "left",
      //   displayinaddForm: "true",
      //   displayineditForm: "true",
      //   displayinlist: "true",
      //   globalSearchField: "false",
      //   required: false,
      //   displayInSettings: true,
      //   fieldType: "customType",
      //   customFieldType: 'innerHTML',
      //   tDisplay: true,
      //   style: {
      //     whiteSpace: "normal",
      //     wordWrap: "break-word",
      //     overflowWrap: "anywhere"
      //   }
      // },
      // {
      //   name: "expectedResult",
      //   type: "textarea",
      //   placeholder: "Expected Result",
      //   label: "Expected Result",
      //   width: "300px",
      //   header: "Expected Result",
      //   field: "expectedResult",
      //   show: true,
      //   textAlign: "left",
      //   displayinaddForm: "true",
      //   displayineditForm: "true",
      //   displayinlist: "true",
      //   globalSearchField: "false",
      //   required: false,
      //   displayInSettings: true,
      //   tDisplay: true,
      //   style: {
      //     whiteSpace: "normal",
      //     wordWrap: "break-word",
      //     overflowWrap: "anywhere"
      //   }
      // },
      // // {
      // //   name: "roles",
      // //   type: "dropDown",
      // //   placeholder: "Roles",
      // //   label: "Roles",
      // //   header: "Roles",
      // //   field: "roles",
      // //   options: roleTypes,
      // //   width: "140px",
      // //   textAlign: "center",
      // //   show: true,
      // //   displayinaddForm: "true",
      // //   displayineditForm: "true",
      // //   displayinlist: "true",
      // //   globalSearchField: "true",
      // //   required: true,
      // //   displayInSettings: true,
      // //   fieldType: "dropDown",
      // //   tDisplay: true,
      // // },
      // {
      //   name: "priority",
      //   type: "dropDown",
      //   placeholder: "Priority",
      //   label: "Priority",
      //   header: "Priority",
      //   field: "priority",
      //   options: priorityTypes,
      //   width: "120px",
      //   textAlign: "center",
      //   show: true,
      //   displayinaddForm: "true",
      //   displayineditForm: "true",
      //   displayinlist: "true",
      //   globalSearchField: "true",
      //   required: true,
      //   displayInSettings: true,
      //   fieldType: "dropDown",
      //   tDisplay: true,
      //   sortable: true,
      //   filter: true,
      //   style: {
      //     textTransform: 'uppercase'
      //   }
      // },
      {
        show: true,
        textAlign: "center",
        width: "100px",
        fieldType: "Actions",
        field: "Actions",
        header: "Actions",
        label: "Actions",
        filter: false,
        sortable: false,
        displayInSettings: true,
        displayinlist: "true",
        displayinaddForm: "true",
        displayineditForm: "true",
        globalSearchField: "false",
        isFieldRequired: "false",
        mobile: true,
        tDisplay: true,
      },
    ];

    return data;
  };


  const additionalFields = [
    {
      description: "Name of the landlord (individual or entity)",
      example: "",
      name: "fileName",
      type: "string",
      ui_component: "text",
    },
  ];

  const getFormFields = (fields = []) => {
    const mergedFields = [...additionalFields, ...fields];

    const mapType = (type) => {
      switch (type) {
        case "string":
          return { type: "text", fieldType: "text" };

        case "date":
          return { type: "date", fieldType: "date" };

        case "number":
          return { type: "number", fieldType: "number" };

        case "currency":
          return { type: "currency", fieldType: "number" };

        case "percentage":
          return { type: "number", fieldType: "number" };

        default:
          return { type: "text", fieldType: "text" };
      }
    };

    const formatLabel = (name) => {
      return name
        ?.toLowerCase()
        ?.replace(/_/g, " ")
        ?.replace(/\b\w/g, (char) => char.toUpperCase());
    };

    return mergedFields.map((field) => {
      const { type, fieldType } = mapType(field.type);

      return {
        show: true,
        name: field.name,
        type: type,
        fieldType: fieldType,
        placeholder: formatLabel(field.name),
        label: field.name,
        id: field.name,
        width: 250,
        description: field.description,
        value: field.example || field.original_value,
        page: field.page,

        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "false",
        required: true,
        globalSearchField: "false",

        isAddFormHidden: false,
        isEditFormHidden: false,
        showInRegenerateForm: true,
        editInRegenerateForm: false,

        ...(type === "textarea" && { rows: "3" }),
        ...(type === "date" && { dateFormat: config.dateDBFormat }),
      };
    });
  };

  const getChangedRoleOptions = () => {
    let fields = getFormFields(templateFields);

    if (fields && fields.length > 0) {
      for (let obj of fields) {
        if (obj.name === "role") {
          obj.options = rolesList?.length ? rolesList : [];
        }
      }
    }

    return fields;
  };


  const displayName = () => {
    if (agreementTemplates && agreementTemplates.length > 0) {
      let selected = agreementTemplates.find(
        (temp) => temp._id === agreementTemplatesId
      );
      return selected ? selected?.fileName : "";
    }
  };

  const fetchAgreementTemplates = () => {
    fetchMethodRequest("GET", apiCalls.agreementTemplates).then((response) => {
      if (response.agreementTemplates) {
        setAgreementTemplates(response.agreementTemplates);
        if (!agreementTemplatesId) {
          navigate(`?agreementTemplates=${response.agreementTemplates[0]._id}`);
        }
        if (agreementTemplatesId && response?.agreementTemplates?.length == 0) {
          navigate(`/agreementTemplates`);
        }
      }
    });
  };
  return (
    <div className="layout-wrapper">
      <div className="side-by-side-container">
        <div className="main-content row">
          {showSideMenu && <AgreementTemplates
            templates={agreementTemplates}
            setTemplates={setAgreementTemplates}
            fetchTemplates={fetchAgreementTemplates}
          />}
          {agreementTemplates && agreementTemplates.length > 0 ? (
            <div className={showSideMenu ? "col-md-9 col-lg-9" : "col-md-12 col-lg-12"}>
              {gotRoles && (
                <DataTables
                  {...props}
                  getTableFields={getTableFields}
                  formFields={getChangedRoleOptions}
                  //
                  addRequired={getChangedRoleOptions().length > 1}
                  editRequired={
                    rolePermission && rolePermission == "Edit" ? true : false
                  }
                  deleteRequired={
                    rolePermission && rolePermission == "Edit" ? true : false
                  }
                  viewRequired={
                    rolePermission && rolePermission == "Edit" ? true : false
                  }
                  exportRequired={
                    rolePermission && rolePermission == "Edit" ? true : false
                  }
                  sample={true}
                  actionsTypes={[
                    {
                      name: "Delete",
                      options: [
                        {
                          label: "Delete",
                          value: "Delete",
                          show:
                            rolePermission && rolePermission == "Edit" ? true : false,
                          multiple: true,
                        },
                      ],
                    },
                  ]}
                  settingsRequired={true}
                  filterRequired={false}
                  gridRequried={false}
                  exportToCsv={true}
                  dateSearchRequired={undefined}
                  searchInDateRangeField={"undefined"}
                  sampleFilePath={filePath.testCases}
                  setData={setData}
                  editSelectedRecord={editSelectedRecord}
                  addSelectedRecord={addSelectedRecord}
                  viewSelectedRecord={viewSelectedRecord}
                  globalSearch={"Search "}
                  displayName={displayName()}
                  type="agreementFiles"
                  routeTo={apiCalls.agreementTemplates}
                  sideFormLeftOrRight="left"
                  displayViewOfForm="screen"
                  apiResponseKey={apiCalls.agreementFiles}
                  apiUrl={apiCalls.agreementFiles}
                  selectedId={params.id}
                  buttonToolTips={{ add: "Add Agreement Template" }}
                  softUpdate={false}
                  softDelete={true}
                  actionOverlayPanel={false}
                  fetchAgreementTemplates={fetchAgreementTemplates}
                  setShowSideMenu={setShowSideMenu}
                  currentTemplate={currentTemplate}
                />
              )}
            </div>
          ) : (
            <div className="col-md-9 col-lg-9 d-flex align-items-center justify-content-center">
              <div
                className="text-center p-5 rounded-3"
                style={{
                  fontSize: "16px",
                  fontWeight: 500,
                  lineHeight: "1.6",
                  width: "80%",
                  minHeight: "200px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                Please create an Agreement Template to continue.
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AgreementFiles;